import { ALL_LESSON_SELECTED } from 'Domains/adaptiveQuiz';
import { SYLLABUS_MODE } from 'Domains/syllabus';

/**
 * Get filter value of adaptive quiz page from query string.
 * `gradeFilter`, `classFilter` and `sectFilter` are kept by individual pages,
 * so they are used first when switching from that page.
 * Lesson is all lessons by default, e.g. when coming from other report pages which have no lesson filter.
 *
 * @param {URLSearchParams} queryString
 */
export const getAdaptiveQuizFilterValue = queryString => {
  const syllabus = queryString.get('course') ?? null;
  return {
    term: queryString.get('term') ?? null,
    grade: queryString.get('gradeFilter') ?? queryString.get('grade') ?? null,
    classNo: queryString.get('classFilter') ?? queryString.get('class') ?? null,
    subject: queryString.get('subj') ?? null,
    syllabus,
    lesson:
      queryString.get('sectFilter') ??
      queryString.get('sect') ??
      (syllabus ? ALL_LESSON_SELECTED : null),
    mode: queryString.get('mode') ?? SYLLABUS_MODE.TRADITIONAL,
  };
};

/**
 * Get filter value of adaptive quiz individual page from query string,
 * which is the filter of adaptive quiz page with the class and lesson name of the report row.
 * All lessons of the student are shown when there is no lesson name.
 *
 * @param {URLSearchParams} queryString
 */
export const getAdaptiveQuizIndividualFilterValue = queryString => ({
  term: queryString.get('term') ?? null,
  grade: queryString.get('grade') ?? null,
  classNo: queryString.get('class') ?? null,
  subject: queryString.get('subj') ?? null,
  syllabus: queryString.get('course') ?? null,
  lesson: ALL_LESSON_SELECTED,
  lessonName: queryString.get('lessonName') ?? null,
  mode: queryString.get('mode') ?? SYLLABUS_MODE.TRADITIONAL,
});

/**
 * Get path of adaptive quiz individual page, which shows the rounds of the student
 * in the lesson of a report row.
 * The filter of adaptive quiz page is kept in `gradeFilter`, `classFilter` and `sectFilter`,
 * the same as individual page of other reports, so it is restored when going back.
 *
 * @param {{ pathname: string, queryString: URLSearchParams, report: object }} params
 */
export const getAdaptiveQuizIndividualPath = ({ pathname, queryString, report }) => {
  const { classroomUsername, classNo, schoolGrade, lessonName } = report;
  const {
    term,
    grade,
    classNo: classFilter,
    subject,
    syllabus,
    lesson: sectFilter,
    mode,
  } = getAdaptiveQuizFilterValue(queryString);
  // lesson is filtered by name, because quiz feed tables have only lesson name
  const encodedLessonName = encodeURIComponent(lessonName);
  return `${pathname}/${classroomUsername}?term=${term}&grade=${schoolGrade.id}&class=${classNo}&subj=${subject}&course=${syllabus}&lessonName=${encodedLessonName}&classFilter=${classFilter}&gradeFilter=${grade}&sectFilter=${sectFilter}&mode=${mode}`;
};
